import { Components } from '@empathybroker/ebx-gluon';

export function applyMixins() {
  Components.Pure.DefaultFacet.mixin({
    computed: {
      cssClasses() {
        return [
          `ebx-facet--${ this.facet.modelName }`,
          {
            'ebx-facet--collapsed': this.collapsed,
            'ebx-facet--preselected': this.facet.preselected,
            'ebx-facet--searchable': this.searchable,
            'ebx-facet--open-search': this.showSearchBox,
            'ebx-facet--has-selected': this.facet.filters.find(filter => filter.selected)
          }
        ];
      }
    } as any
  });
}
